import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../config/axiosInterceptor";
import { CreateDealType, SubmitEstimateType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const createPotentialDeal = (
  payload: CreateDealType
): Promise<AxiosResponse<CreateDealType>> => {
  return axios.post(`${baseURL}createPotentialDeal`, payload);
};

export const deletePotentialDeal = (
  dealIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deletePotentialDeal`, { data: dealIds });
};

export const changePotentialDealStatus = (
  id: string,
  payload: {
    status: string;
  }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}changePotentialDealStatus/${id}`, payload);
};

export const updatePotentialDealById = (
  id: string,
  payload: CreateDealType
): Promise<AxiosResponse<CreateDealType>> => {
  return axios.patch(`${baseURL}updatePotentialDealById/${id}`, payload);
};

export const saveProposal = (
  payload: SubmitEstimateType
): Promise<AxiosResponse<SubmitEstimateType>> => {
  return axios.post(`${baseURL}saveProposal`, payload);
};

export const deleteProposalById = (
  id: string
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteProposalById/${id}`);
};

export const updateProposalById = (
  id: string,
  payload: { summary: string }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}updateProposalById/${id}`, payload);
};

export const changeProposalStatus = (
  payload: { status: string; deal_id: string },
  id: string
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}changeProposalStatus/${id}`, payload);
};

export const sentProposalDoc = (payload: {
  proposal_id: string;
}): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}sentProposalDoc`, payload);
};

// export const updateCompanyClientManager = (
//   id: string,
//   payload: UpdateCompanyClientManagerType
// ): Promise<AxiosResponse<UpdateCompanyClientManagerType>> => {
//   return axios.patch(`${baseURL}updateCompanyClientManager/${id}`, payload);
// };
